import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { promoActive } from '../common/promo';

const { FiArrowUpRight, FiCreditCard } = FiIcons;

const tickets = [
  {
    type: 'BOLETO INDIVIDUAL',
    price: '$150',
    unit: 'MXN / PERSONA',
    description:
      'Acceso al sábado 14 de noviembre en el Hotel Fiesta Inn Plaza San Marcos. Para tabuladores, Equipos del Mundo y Equipos del Mundo Activo.',
    button: 'COMPRAR BOLETO',
    url: 'https://rafaelrodriguez.thrivecart.com/boleto-escuela-de-mayoristas-noviembre-2026/',
    checkoutEvent: {
      content_name: 'Boleto individual',
      value: 150,
      currency: 'MXN',
    },
  },
  {
    type: 'PAQUETE DE 6 BOLETOS',
    price: '$800',
    unit: 'MXN / 6 PERSONAS',
    description: 'Sale en $133 por persona',
    benefits: [
      'Promoción vigente hasta el 31 de octubre',
      'Ahorras $100 frente a comprar 6 boletos por separado',
      'Ideal para llevar a tu primera línea',
    ],
    button: 'COMPRAR PAQUETE',
    url: 'https://rafaelrodriguez.thrivecart.com/boleto-escuela-de-mayoristas-noviembre-combo/',
    checkoutEvent: {
      content_name: 'Paquete 6',
      value: 800,
      currency: 'MXN',
    },
    featured: true,
    promo: true,
  },
];

export default function Tickets() {
  const visible = tickets.filter((t) => !t.promo || promoActive());
  const handleCheckout = (checkoutEvent) => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', checkoutEvent);
    }
  };

  return (
    <section className="section tickets-section" id="boletos">
      <div className="container">
        <div className="section-top">
          <span className="eyebrow">04 / BOLETOS</span>
          <span className="section-rule" />
        </div>
        <div className="tickets-heading">
          <h2>
            Tu lugar<br />
            <span>te espera.</span>
          </h2>
          <p>Elige cómo vivir esta experiencia. Los lugares son limitados.</p>
        </div>
        <div className={`tickets-grid ${visible.length === 1 ? 'single' : ''}`}>
          {visible.map((ticket) => (
            <article
              className={`ticket-card ${ticket.featured ? 'featured' : ''}`}
              key={ticket.type}
            >
              <div className="ticket-top">
                <span>{ticket.type}</span>
                {ticket.featured && (
                  <span className="ticket-badge">MEJOR PARA EQUIPOS</span>
                )}
              </div>
              <div className="ticket-price">
                {ticket.price}
                <span>{ticket.unit}</span>
              </div>
              <div className="ticket-divider" />
              <p>{ticket.description}</p>
              {ticket.benefits && (
                <ul className="ticket-benefits">
                  {ticket.benefits.map((benefit) => (
                    <li key={benefit}>{benefit}</li>
                  ))}
                </ul>
              )}
              <a
                className={`button ${ticket.featured ? 'button-dark' : 'button-gold'}`}
                href={ticket.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => handleCheckout(ticket.checkoutEvent)}
              >
                {ticket.button} <SafeIcon icon={FiArrowUpRight} />
              </a>
            </article>
          ))}
        </div>
        <p className="payment-note">
          <SafeIcon icon={FiCreditCard} /> Pago con tarjeta de crédito,débito o PayPal
        </p>
      </div>
    </section>
  );
}